import {
	isFixRelayIdConflictForHelpObjectStoreEnabled,
	isFixRelayIdConflictInHelpCenter,
} from '@helpcenter/feature-flags';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { createRelayEnvironment } from '@atlassian/relay-environment';

import RelayEnvironment, { resolveGetDataID } from './environment';
import fetchOptions from './fetch-options';
import { QueryResponseCache } from './query-responses';
import { subscribeOptions } from './subscribe';

const resolveSharedRelayGetDataIDConfig = () => {
	if (isFixRelayIdConflictForHelpObjectStoreEnabled()) {
		return { getDataID: resolveGetDataID() };
	}

	if (!isFixRelayIdConflictInHelpCenter()) {
		return { getDataID: undefined };
	}

	return {};
};

const sharedRelayEnvironment = createRelayEnvironment({
	...resolveSharedRelayGetDataIDConfig(),
	networkOptions: {
		setEndpoint: fetchOptions.setEndpoint,
		getHeaders: fetchOptions.getHeaders,
		isServer: __SERVER__,
		subscribeExtensions: subscribeOptions.extensions,

		onSubscribeError: subscribeOptions.onError,

		onSubscribeTrigger: subscribeOptions.onTrigger,
		queryResponseCache: QueryResponseCache,
		validateResponse: fetchOptions.validateResponse,
		onFetchError: fetchOptions.onFetchError,
	},
});

export const getRelayEnvironment = () => {
	if (fg('platform_relay_use_shared_relay_env_help_center')) {
		return sharedRelayEnvironment;
	}

	return RelayEnvironment;
};

export { getRelayDataId } from './data-id';
